import { render, staticRenderFns } from "./InspectionReportEdit.vue?vue&type=template&id=136f08c2&"
import script from "./InspectionReportEdit.vue?vue&type=script&lang=js&"
export * from "./InspectionReportEdit.vue?vue&type=script&lang=js&"
import style0 from "./InspectionReportEdit.vue?vue&type=style&index=0&id=136f08c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports